import Vue from 'vue'

const search = () => {
  return Vue.prototype.$http.get('tasks')
}

export default {
  search,
}
